import React from "react";

import { AiFillAudio } from "react-icons/ai";
import AuditionCardSchedule from "../Reuse/AuditionCardSchedule";

const AuditionSchedule = () => {
  return (
    <>
      <div className="row">
        <AuditionCardSchedule
          link={"/audition-admin/schedule"}
          title={"Audition"}
          icon={<AiFillAudio size={50} />}
        />
      </div>
    </>
  );
};

export default AuditionSchedule;
